<template>
  <a-result status="403" title="403" sub-title="对不起, 您暂无权限访问该页面.">
    <template #extra>
      <a-button v-if="hasPermissions" type="primary" @click="toHome">
        返回上一页
      </a-button>
    </template>
  </a-result>
</template>

<script>
import storage from 'store'

export default {
  name: 'Exception403',
  computed: {
    hasPermissions() {
      const permissions = storage.get('permissions')
      const slug = permissions?.slug || []
      return slug.length > 0
    }
  },
  methods: {
    toHome () {
      this.$router.go(-1)
    }
  }
}
</script>
